import api from "./axiosInterceptor";

export const getSignals = (page=1) =>
  api.get(`/signals/watch-signals?ordering=-timestamp&page=${page}`);